<template>
  <div style="padding: 50px 0;">
    <el-form ref="form" :model="form" :rules="rules" label-suffix="：" label-width="auto">
      <el-form-item label="运输单号">
        {{ form.bizNo }}
      </el-form-item>
      <el-form-item prop="freightAmount" label="运输费用(元)">
        <el-input
          v-model="form.freightAmount"
          placeholder="请输入运输费用"
        ></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { checkMoney } from '@/utils/validate'
export default {
  name: "Supply",
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {
        freightAmount: '',
      },
      rules: {
        freightAmount: [{ required: true,  validator: checkMoney(2),  trigger: ['blur', 'change'] }],
      },
    }
  },
  watch: {
    data: {
      handler(form) {
        if (!form) return 
        this.form = {
          freightAmount: form.freightAmount,
          bizNo: form.bizNo,
          id: form.id,
        }
      },
      deep: true,
      immediate: true,
    }
  },
  methods: {
    submit() {
      return new Promise((resolve, reject) => {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
              resolve(this.form)
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>

<style scoped lang="less">
@import '../../../../assets/form.less';

::v-deep {
  .el-form-item__label {
    color: #000;
  }
}
</style>
